import { Box, Button, MenuItem } from "@mui/material";
import TextField from "components/common/TextField";
import Select from "components/common/Select";
import { EventReminder } from "protogen/calendar_pb";
import { X } from "lucide-react";
import useIsMobile from "components/hooks/useIsMobile";

const reminderUnitOptions = ["minutes", "hours", "days", "weeks"];

interface ReminderInputProps {
  reminder: EventReminder;
  index: number;
  onUpdate: (index: number, reminder: EventReminder) => void;
  onDelete: (index: number) => void;
}

const ReminderInput = ({
  reminder,
  index,
  onUpdate,
  onDelete,
}: ReminderInputProps) => {
  const isMobile = useIsMobile();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <TextField
        fullWidth
        value={reminder.value}
        type="number"
        onChange={(e) => {
          onUpdate(
            index,
            new EventReminder({
              ...reminder,
              value: parseInt(e.target.value, 10) || 0,
            }),
          );
        }}
        autoComplete="off"
        sx={{
          margin: "12px 0px",
          width: "40%",
          "& .MuiInputBase-root": {
            minHeight: "48px !important",
          },
          "& .MuiInputBase-input": {
            marginTop: "0px",
            paddingRight: "0px",
          },
        }}
      />
      <Select
        variant="detachedOutlined"
        size="small"
        value={reminder.unit}
        renderValue={(value) => {
          return value;
        }}
        onChange={(e) => {
          onUpdate(
            index,
            new EventReminder({
              ...reminder,
              unit: e.target.value as string,
            }),
          );
        }}
      >
        {reminderUnitOptions.map((v) => (
          <MenuItem value={v} key={v}>
            {v}
          </MenuItem>
        ))}
      </Select>
      <Button
        variant="text"
        sx={{ minWidth: isMobile ? "40px" : "auto" }}
        onClick={() => onDelete(index)}
      >
        <X size={24} stroke="#8E9598"></X>
      </Button>
    </Box>
  );
};

export default ReminderInput;
